// src/helpers/locations/dropdown.ts
var getLocationsDropdownData = (locationGroups, accessLocations = [], hideMasterMode = false) => {
  const locationsArray = hideMasterMode ? [] : [{ label: "Enterprise", value: 0 }];
  Object.values(locationGroups).forEach((locationGroup) => {
    locationGroup.locations.forEach((location) => {
      if (accessLocations.find((ele) => ele === location.id)) {
        locationsArray.push({
          label: location.name || location.streetLine1,
          value: location.id
        });
      }
    });
  });
  return locationsArray;
};

export { getLocationsDropdownData };
